module.exports = __webpack_public_path__ + "img/1f8beb7.jpg";